
const containsSpecial = (string) => {
    if (!string) return false
    return (/[@#$%^&*()_+={};':"|,.<>?!]/g.test(string))
}

const containsCapital = (string) => {
    if (!string) return false
    return (/[A-Z]/.test(string))
}

const containsDigit = (string) => {
    if (!string) return false
    return /\d/g.test(string)
}

const titleCase = (str) => {
    if (!str) return ""
    return str.toLowerCase().split(' ').map(function(word) {
        return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

export default {
    containsSpecial,
    containsCapital,
    containsDigit,
    titleCase
}